export const color = [
  "white",
  "Black",
  "Red",
  "Marun",
  "Being",
  "Pink",
  "Green",
  "Yellow",
];

export const filters = [
  {
    id: "color",
    name: "Color",
    options: [
      { value: "white", label: "White" },
      { value: "beige", label: "Beige" },
      { value: "black", label: "Black" },
      { value: "blue", label: "Blue" },
      { value: "navy", label: "Navy" },
      { value: "brown", label: "Brown" },
      { value: "gray", label: "Gray" },
      { value: "green", label: "Green" },
      { value: "olive", label: "Olive" },
      { value: "purple", label: "Purple" },
      { value: "red", label: "Red" },
      { value: "pink", label: "Pink" },
      { value: "yellow", label: "Yellow" },
      { value: "orange", label: "Orange" },
    ],
  },
  {
    id: "size",
    name: "Size",
    options: [
      { value: "S", label: "S" },
      { value: "M", label: "M" },
      { value: "L", label: "L" },
    ],
  },
];

export const singleFilter = [
  {
    id: "discount",
    name: "Discount Range",
    options: [
      { value: "10", label: "10% And Above" },
      { value: "20", label: "20% And Above" },
      { value: "30", label: "30% And Above" },
      { value: "40", label: "40% And Above" },
      { value: "50", label: "50% And Above" },
      { value: "60", label: "60% And Above" },
      { value: "70", label: "70% And Above" },
      { value: "80", label: "80% And Above" },
    ],
  },
  {
    id: "stock",
    name: "Availability",
    options: [
      { value: "in_stock", label: "In Stock" },
      { value: "out_of_stock", label: "Out Of Stock" },
    ],
  },
];
